import { Routes } from '@angular/router';
import { EditProfileComponent } from 'src/core/components/shared/profile/edit/edit-profile.component';

export const profileRoutes: Routes = [
  {
    path: '',
    component: EditProfileComponent,
  },
];
